import React, {useEffect, useState} from "react";
import {Alert, Backdrop, Button, CircularProgress, Container, Divider, Menu, MenuItem, styled} from "@mui/material";
import {useLocation} from "react-router-dom";
import NpiPagePasteURLPanel from "./NpiPagePasteURLPanel";
import NpiPageInstruction from "./NpiPageInstruction";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ExternalSourceBreadcrumbs from "../ExternalSourceManagement/ExternalSourceBreadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {batchCurrentStatus} from "../ExternalSourceManagement/ExternalSourceManagementHome";
import ShowSnackbar from "../utils/ShowSnackbar";
import {getAllBatches} from "../features/allBatchesSlice";
import ExternalSourceBatchProgressBar from "../ExternalSourceManagement/ExternalSourceBatchProgressBar";

const StyledContainer = styled(Container)(({theme}) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),

}))
const StyledDiv = styled('div') ({
    display: "flex",
    float: "right",
    gap: "10px",

})
export default function NpiNewImportTask(props) {
    const location = useLocation();
    const path = location.pathname;

    // const [msg, setMsg] = useState({});
    // const [batch, setBatch] = useState(null);
    // const [loading, setLoading] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState({ open: false, msg: '', msgLv: ''});
    const [fullOrIncremental, setFullOrIncremental] = useState();
    const [buttonTitle, setButtonTitle] = useState("Full or Incremental")
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    // const {npiBatchId, npiStatus} = useSelector(state => state.npiBatch);
    const { nppesBatches, batchRefresh } = useSelector(state => state.allBatches)
    const dispatch = useDispatch();

    useEffect(() => {
        // getActiveBatchProgress('NPI', setLoading, setSnackbarMsg)
        //     .then( res => {
        //         dispatch(addNpiBatch(res));
        //     })

        dispatch(getAllBatches());
    }, [batchRefresh])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleFullClose = () => {
        setAnchorEl(null);
        setFullOrIncremental("Full")
        setButtonTitle("Full");
    };

    const handleIncrementalClose = () => {
        setAnchorEl(null)
        setFullOrIncremental("Incremental");
        setButtonTitle("Incremental");
    }

    return (
        <StyledContainer>
            <ExternalSourceBreadcrumbs path={path} />
            <h3 className="title">
                    New NPI Import Task
                <StyledDiv>
                    <Button variant="outlined" href="https://download.cms.gov/nppes/NPI_Files.html" target="_blank">NPI Files</Button>
                </StyledDiv>
            </h3>

            {/* Menu button: Full import or incremental import*/}
            <Button
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                variant="contained"
                endIcon={<KeyboardArrowDownIcon />}
            >
                {buttonTitle}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem onClick={handleFullClose}>Full NPI File (Monthly)</MenuItem>
                <MenuItem onClick={handleIncrementalClose}>Incremental NPI File (Weekly)</MenuItem>
            </Menu>

            {fullOrIncremental &&
                <NpiPagePasteURLPanel
                    setMsg={(m) => setMsg(m)}
                    setBatch={(b) => setBatch(b)}
                    fullOrIncremental={fullOrIncremental}
                /> }

            <br/>
            {/*{npiStatus && npiStatus !== 'Init' && <Alert severity={batchCurrentStatus[npiStatus].getStatus} icon={false}>{batchCurrentStatus[npiStatus].getMsg("NPPESNPI")}</Alert> }*/}
            {nppesBatches.length > 0 && nppesBatches[0].status !== 'Init' && <Alert severity={batchCurrentStatus[nppesBatches[0].status].getStatus} icon={false}>{batchCurrentStatus[nppesBatches[0].status].getMsg("NPPESNPI")}</Alert> }
            <br/>

            { nppesBatches.length > 0 && nppesBatches[0].status !== 'Cancelled' && nppesBatches[0].status !== 'Failed' && nppesBatches[0].status !== 'Completed' &&
                // <NpiBatchProgressBar batch={nppesBatches[0]}/>}
            <ExternalSourceBatchProgressBar batch={nppesBatches[0]}/>}

            <br />
            <br />
            <Divider sx={{borderBottomWidth: 5}}>
                <div>
                    <ArrowDropDownIcon /><strong style={{fontSize: "24px"}}>Instruction</strong><ArrowDropDownIcon />
                </div>
            </Divider>

            <NpiPageInstruction />
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
        </StyledContainer>
    );
}